import { Config } from '../Constants/Config';
import jwtDecode from "jwt-decode";

const AuthProvider = {
    login: ({ username, password }) => {
        var clientId = Config.clientId;
        var clientSecret = Config.clientSecret;
        var basicAuth = 'Basic ' + btoa(clientId + ':' + clientSecret);
        let formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('grant_type', 'password');
        const request = new Request(Config.a3sUrl + '/oauth/token', {
            method: 'POST',
            body: formData,
            headers: new Headers({ Authorization: basicAuth }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ access_token }) => {
                const values = jwtDecode(access_token);
                localStorage.setItem('access_token', access_token);
                localStorage.setItem("user_name", values.user_name);
                localStorage.setItem("permissions", values.authorities);
            });
    },
    logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem("user_name");
        localStorage.removeItem("permissions");
        return Promise.resolve();
    },
    checkError: ({ status }) => {
        console.log(status)
        if (status === 401 || status === 403) {
            localStorage.removeItem('access_token');
            localStorage.removeItem("user_name");
            localStorage.removeItem("permissions");
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        return localStorage.getItem('access_token')
            ? Promise.resolve()
            : Promise.reject();
    },
    getPermissions: () => {
        const permissions = localStorage.getItem("permissions");
        const authorities = permissions === null ? [] : permissions.split(",") || [];
        let role = 'USER';
        authorities.forEach((authority) => {
            if (authority === "arms:read") {
                if (role !== "ADMIN") {
                    role = 'USER';
                }
            } else if (authority === "arms:write") {
                role = "ADMIN";
            }
        });
        return role
            ? Promise.resolve(role)
            : Promise.reject();
    },
    getIdentity: () => {
        try {
            const { id, fullName, avatar } = { id: "", fullName: "PARS Admin", avatar: "" }
            return Promise.resolve({ id, fullName, avatar });
        } catch (error) {
            return Promise.reject(error);
        }
    }
};

export default AuthProvider;